import { render, staticRenderFns } from "./MedicationAdherenceBarriers.vue?vue&type=template&id=27c7dcac&"
import script from "./MedicationAdherenceBarriers.vue?vue&type=script&lang=js&"
export * from "./MedicationAdherenceBarriers.vue?vue&type=script&lang=js&"
import style0 from "./MedicationAdherenceBarriers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VChipGroup,VCol,VRow})
